import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MutationResult } from 'apollo-angular';
import { NgxPermissionsService } from 'ngx-permissions';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, Observable } from 'rxjs';

import {
  LoginGQL,
  type LoginInput,
  LoginMutation,
  LogoutGQL,
} from '../../../graphql/client/generated-types';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private permissionsService: NgxPermissionsService,
    private router: Router,
    private modal: NgbModal,
    private toastrService: ToastrService,
    private loginGQL: LoginGQL,
    private logoutGQL: LogoutGQL,
  ) {}

  login(
    userCredentials: LoginInput,
  ): Observable<MutationResult<LoginMutation>> {
    return this.loginGQL.mutate(
      {
        input: userCredentials,
      },
      {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    );
  }

  async logout() {
    this.modal.dismissAll();
    this.toastrService.clear();

    const { data: logoutResult, errors: logoutErrors } = await firstValueFrom(
      this.logoutGQL.mutate(
        {},
        {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
      ),
    );

    if (logoutResult?.logout) {
      this.clearStorage();
      this.permissionsService.flushPermissions();

      await this.router.navigateByUrl('/login');
    } else if (logoutErrors !== undefined) {
      this.toastrService.error('An error occurred while logging out.');
    }
  }

  async silentLogout() {
    this.modal.dismissAll();
    this.toastrService.clear();

    const { data: logoutResult, errors: logoutErrors } = await firstValueFrom(
      this.logoutGQL.mutate(
        {},
        {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
      ),
    );

    if (logoutResult?.logout) {
      this.clearStorage();
      this.permissionsService.flushPermissions();

      await this.router.navigateByUrl('/login');
    } else if (logoutErrors !== undefined) {
      this.toastrService.error('An error occurred while logging out.');
    }
  }

  private clearStorage() {
    localStorage.removeItem('user');
    localStorage.removeItem('credentials');
    localStorage.removeItem('token');
    localStorage.removeItem('permissions');
  }
}
